import { d as t, _ as l } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as c, normalizeClass as r, normalizeStyle as n, createTextVNode as a, createElementVNode as o } from "vue";
const i = t("voice"), p = /* @__PURE__ */ o("path", {
  d: "m636.165 957.44-70.804-70.81c107.591-92.062 176.03-228.587 176.03-381.317 0-145.495-62.284-276.121-161.177-367.774l70.978-70.979c117.013 109.83 190.51 265.477 190.51 438.61 0 180.444-79.78 341.908-205.537 452.27z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), m = /* @__PURE__ */ o("path", {
  d: "m445.087 766.356-72.94-72.929c66.284-36.644 111.191-107.167 111.191-188.257 0-73.615-37.048-138.522-93.47-177.29l71.623-71.614c74.23 57.708 122.189 147.615 122.189 248.904 0 108.657-54.958 204.447-138.593 261.186zm-191.12-175.17c-39.577 0-71.67-32.082-71.67-71.675 0-39.598 32.088-71.675 71.67-71.675 39.609 0 71.68 32.077 71.68 71.675 0 39.593-32.071 71.675-71.68 71.675z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1);
function d(e, f, _, u, h, v) {
  return s(), c("svg", {
    class: r(e.classes),
    style: n(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, [
    p,
    a(","),
    m
  ], 6);
}
const z = /* @__PURE__ */ l(i, [["render", d]]);
export {
  z as default
};
